function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,1)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 727 0 C 563 0 500 146 499 147 C 499 146 436 0 272 0 C 107 0 0 132 45 361 C 97 621 387 737 499 929 L 499 929 C 500 929 500 929 500 929 L 500 929 C 612 737 902 621 954 361 C 1000 132 892 0 727 0 z M 760 484 L 658 484 C 653 484 647 482 644 477 L 600 417 L 516 676 C 514 684 507 689 500 689 C 499 689 499 688 498 688 C 490 688 483 682 482 674 L 428 335 L 386 472 C 383 480 377 484 369 484 L 239 484 C 230 484 222 477 222 467 C 222 457 230 450 239 450 L 356 450 L 417 253 C 419 245 427 240 435 240 C 443 241 450 247 451 255 L 505 596 L 577 374 C 579 368 584 363 591 362 C 597 361 604 364 608 369 L 667 450 L 760 450 C 769 450 777 457 777 467 C 777 477 769 484 760 484 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeIcon);
export default __webpack_public_path__ + "static/media/life-icon.16ce11942c221ef8b8dc765e7997b775.svg";
export { ForwardRef as ReactComponent };